<script>
    import { onMount } from "svelte";
    import HelpCard from "./components/helpCard.svelte";
    import Spinner from "./components/spinner.svelte";
    import Modal from "./components/modal.svelte";
    import ModalConfirm from "./components/modalconfirm.svelte";
    import {validate} from "../components/validate-action"
	  import { AuthUser } from "../store.js";
    import wrappedFetch from "../wrappedFetch.js";

    let isPageLoading;

    onMount(async () => {
        isPageLoading = true;
        isPageLoading = false;
    });

    let params;

    let form;
    let subject="";
    let message="";
    let nameP = "";
    let mailAddr = "";
    let mobile = "";
    let showModal = false;
    let showFeedbackModal = false;
    let showConfirmModal = false;
    let errormsg = "";
    let isButtonLoading = false;
    let isACSCustomer = false;

	  async function  handleContactModal(event) {
      let resp = await wrappedFetch('/api/Subscriptions/IsDoncasterSchool?schoolId=' + $AuthUser.schoolId, {method: "get"}); 
        isACSCustomer = await resp.json();       
		  showModal = true;
    }

	  function handleContactReset() {
		  showModal = false;
    }
    
    const handleReset = async () => {
        showFeedbackModal = false;
    };

    function handleFeedbackModal(event) {
        FindByPersonId();
        showFeedbackModal = true;
    }

    const ToggleIcons = async (Number) => {
      jQuery("#collapse" + Number).on('show.bs.collapse', function(){
        jQuery("#icon" + Number).removeClass("fa-plus").addClass("fa-minus");;
        }).on('hide.bs.collapse', function(){
          jQuery("#icon" + Number).removeClass("fa-minus").addClass("fa-plus");
        });
    }
    
    let Details = [];
    const FindByPersonId=async()=>{
        let resp = await wrappedFetch('/api/Account/GetPersonAccount?pid=' + $AuthUser.personId, {method: "get"}); 
        Details = await resp.json();
        showFeedbackModal = true;
        nameP = Details.nameP;
        mailAddr = Details.mailAddr;
        mobile = Details.mobile;
     }
        
    const RunFeedback = async () => {  
        var isValid = jQuery(form).valid();
        errormsg = "";

        if (isValid) {
          isButtonLoading = true;
            var data = {
                nameP: nameP,
                mailAddr: mailAddr,
                mobile: mobile,
                subject: subject,
                message: message
            }
            let res = await wrappedFetch(
                `/api/User/SendFeedbackResponse`,
                {
                    method: "post",
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            ).then(r=> r.json())
            .catch(error=> {return { message : "Unexpected error. Please try again."}});
            isButtonLoading = false;
            showFeedbackModal = false;
            showConfirmModal = true;
        }
        else {
            errormsg = "Some fields are invalid";
        }
    }
</script>

<style>
  .updown{
    float: right;
    margin-top: 5px;
    color: #2e817d;
  }
      
  @media (max-width: 576px) {
      .p-xs-1 {
          padding: 0.25rem !important;
      }
  }
</style>

<svelte:head>
    <title>Help | Wavenet Nimbus</title>
</svelte:head>

{#if isPageLoading}
    <Spinner />
{:else}
    <div class="container">
        <div class="row mb-3">
            <div class="col-12">
                <img src="/images/Nimbus_Banner_Help.jpg" width="100%" alt="Help image" />
            </div>
        </div>
        <div class="row">
            <div class="d-flex col col-12 col-lg-4 mb-3">
                <HelpCard imgSrc="/images/Nimbus_Help_Icons_SupportCase.png"
                  headerText="Support Case"
                  mainContent="Raise a query or issue with our Support Team via the Issue Tracker."
                  buttonText="Raise or view a case"
                  targetUrl="https://tracker.adept.education/"/>                  
            </div>

            <div class="d-flex col col-12 col-lg-4 mb-3">
                <HelpCard imgSrc="/images/Nimbus_Help_Icons_Documentation.png"
                  headerText="User Guide"
                  mainContent="View our guide for info on configuring Wavenet Nimbus and answers to frequently asked questions. "
                  buttonText="View Guide"
                  targetUrl="/user_guide/help.html"/>                   
            </div>

            <div class="d-flex col col-12 col-lg-4 mb-3">
                <HelpCard imgSrc="/images/Nimbus_Help_Icons_Call.png" on:handleContactModal={handleContactModal}
                headerText="Call Us"
                 mainContent="Speak to us regarding Wavenet Nimbus or anything else we may be able to assist with."
                 buttonText="Get contact details"
                 modalLink="true"/>                    
            </div>
        </div>
        <div class="row">
            <div class="d-flex col-4 col-md-4 mb-3 p-xs-1">
               <HelpCard isRounded={true} targetUrl="https://www.wavenet.co.uk/who-we-are" icon="info" linkText="About Wavenet" title="Visit our website"/>   
            </div>
            <div class="d-flex col-4 col-md-4 mb-3 p-xs-1">
                <HelpCard isRounded={true} targetUrl="/lib/Privacy-Notice.pdf" icon="privacy_tip" linkText="Privacy Policy" title="View our privacy policy documentation"/> 
            </div>
            <!-- <div class="d-flex col-6 col-lg-3 mb-3">
                <HelpCard isRounded={true} targetUrl="#" icon="lock" linkText="Data Protection" title="View our data protection documentation"/>
            </div>    -->
            <div class="d-flex col-4 col-md-4 mb-3 p-xs-1">
                <HelpCard isRounded={true} modalLink="true" icon="chat_bubble" linkText="Feedback" title="Submit feedback" on:handleFeedbackModal={handleFeedbackModal} />
            </div>
        </div>
    </div>
{/if}

  

<Modal 
    showModal={showModal}
    targetClass="preview" 
    buttonText = 'Close'
    buttonClass="btn-primary"
    sizeClass="modal-lg"
    showFooter={false}
    on:close={handleContactReset} >
    <div slot="header">
        <h4 class="title">Call Us</h4>
    </div>
    <div slot="content">
        <p>Please select the team below that's most relevant to your query. </p>

        <div class="accordion" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button id="buttonOne" class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" on:click={ async () => {ToggleIcons('One');}}>
                    <i id="iconOne" class="fa fa-minus updown"></i>Support Team
                  </button>
                </h2>
              </div>
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                  {#if isACSCustomer}
                  <p>Please call <a href="tel:01302774820">01302774820</a> to speak to a member of our support team. </p>
                  {:else}
                  <p>Please call <a href="tel:01689814777">01689 814777</a> to speak to a member of our support team. </p>
                  <p>Our opening hours are Monday to Friday 8am-6pm except for public holidays. </p>
                  <p>When calling you will be asked for your establishment's DfE code. The DfE code for your school is {$AuthUser.dfes}.</p>
                  {/if}                 
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button id="buttonTwo" class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" on:click={ async () => {ToggleIcons('Two');}}>
                    <i id="iconTwo" class="fa fa-plus updown"></i>Sales Team
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                    <p>We have a sales team based at both of our offices in Orpington and Doncaster. If you want to contact us, we recommend contacting the team closest to you in the first instance. </p>
                    <p>For our Orpington office, please call <a href="tel:01689814700">01689 814700</a>.</p>
                  <p>For our Doncaster office, please call <a href="tel:01302774820">01302 774820</a>.</p>
                </div>
              </div>
            </div>
        </div>
    </div>
</Modal>




<ModalConfirm
  showModal={showFeedbackModal}
  zindex="1052"
  sizeClass="modal-lg"  
  targetClass="confirm-options"
  showCancel={true}
  buttonClass="btn-primary"
  buttonText="Submit"
  bind:isLoading = {isButtonLoading}
  on:confirm={RunFeedback}
  on:close={handleReset}>

  <div slot="header">  
      <h4 class="title">Feedback</h4>
  </div>

  <form bind:this={form} slot="content" use:validate={{
    rules:{
        FeedbackSubject:{"required":true},
        FeedbackMessage:{"required":true}
    }}}>
    <p class="col">Please complete this form to submit any feedback to our product team. This could include anything you like or dislike about the current platform or feature ideas you would like to see in the future. We really appreciate all feedback and would love to hear from you.  </p>

    {#if errormsg}
    <div class="col-md-12" id="plIntroSignUpConfirm">
        <div class="alert alert-danger">{@html errormsg}</div>
    </div>
    {/if}
    
    <div class="row m-0 p-0">
      <div class="col-md-4">
          <div class="form-group">
            <label class="labeldisabled">Name</label><br />
            <input
                name="FeedbackName"
                type="text"
                class="form-control"
                bind:value={nameP}
            />
            <label for="FeedbackName" class="text-danger" style="display:none" />
          </div>
        </div>
        
      <div class="col-md-4">
          <div class="form-group">
            <label class="labeldisabled">Email</label><br/>
            <input
                name="FeedbackEmail"
                type="text"
                class="form-control"
                bind:value={mailAddr}
                            />
            <label for="FeedbackEmail" class="text-danger" style="display:none" />
          </div>
          
        </div>
        
        <div class="col-md-4">
          <div class="form-group">
            <label class="labeldisabled">Phone Number</label><br />
            <input
                name="FeedbackPhone"
                type="text"
                class="form-control"
                bind:value={mobile}
                
            />
            <label for="FeedbackPhone" class="text-danger" style="display:none" />
   
          </div>

        </div>
        
        <div class="col-md-12">
          
          <div class="form-group">
            <label class="labeldisabled">Subject</label><span style="color: rgb(204, 4, 4);"> *</span><br />
            <input
                name="FeedbackSubject"
                type="text"
                class="form-control"
                bind:value={subject}
                required
            />
            <label for="FeedbackSubject" class="text-danger" style="display:none" />
   
          </div>
          
        </div>
        
        <div class="col-md-12">
          <div class="form-group">
            <label class="labeldisabled">Message</label><span style="color: rgb(204, 4, 4);"> *</span><br />
            <textarea
                name="FeedbackMessage"
                class="form-control"
                bind:value={message}
                rows="5"
                required
            />
            <label for="FeedbackMessage" class="text-danger" style="display:none" />
   
          </div>
      </div>
  </div>
  </form>
</ModalConfirm>
  
<Modal 
  bind:showModal={showConfirmModal}
  on:close={()=>{showConfirmModal=false;}}
  targetClass="preview" 
  sizeClass="modal-md"
  showFooter={false}>
    <div slot="header">
      <h4 class="title">Feedback</h4>
    </div>
    <div slot="content">
      <div class="alert alert-success">Your feedback has been sent.</div>
    </div>
</Modal>
